import { isMessageParentAvailable } from "./officeDialog";

let isAuthRefreshActive = false;

export const canInitiateAuthRefresh = (): boolean => {
  // isMessageParentAvailable returns true if running inside the office dialog
  // we don't want to initiate a refresh if we're in the dialog
  if (isAuthRefreshActive || isMessageParentAvailable()) {
    return false;
  }

  isAuthRefreshActive = true;

  return true;
};


export const resetAuthRefreshState = (): void => {
  isAuthRefreshActive = false;
};

